<template>
  <main class="section">
    <template v-if="post">
      <h2 class="title is-2">{{ post.title.rendered }}</h2>
      <div class="content post-contents" v-html="post.content.rendered"></div>
    </template>
    <Loader v-else />
  </main>
</template>

<script>
  import axios from "axios";
  import Loader from "../partials/Loader.vue";
  import {
    mapGetters
  } from "vuex";
  import SETTINGS from "../../settings";

  export default {
    data() {
      let head = this.getHeadMetaFromPost(null);
      return {
        post: false,
        //seo
        title: head.title,
        link: head.link,
        meta: head.meta,
      };
    },
    head: {
      title: function () {
        return this.title
      },
      link: function () {
        return this.link
      },
      meta: function () {
        return this.meta
      },
    },
    computed: {},

    beforeMount() {
      this.getPost();
    },

    methods: {
      getPost: function () {
        axios
          .get(
            SETTINGS.API_BASE_PATH + "posts?slug=" + this.$route.params.postSlug
          )
          .then(response => {
            this.post = response.data[0];
            // vue head
            let head = this.getHeadMetaFromPost(this.post, "article");
            this.title = head.title;
            this.meta = head.meta;
            this.link = head.link;
            this.$emit('updateHead');
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    components: {
      Loader
    }
  };
</script>